const getDefaultState = () => {
    return {
        projectModuleStatus: ['active', 'archived', 'closed', 'deleted'],
        treeview: [],
    }
}

const state = getDefaultState()

const getters = {
    projectModuleStatus(state: any) {
        return state.projectModuleStatus
    },

    treeviews(state: any) {
        return state.treeview
    },

    treeview: (state: any) => (id: string) => {
        return state.treeview.findIndex((item: any) => {
            return item == id
        })
    },
}

const mutations = {
    openTreeView(state: any, payload: any) {
        state.treeview.push(payload)
    },

    closeTreeview(state: any, payload: any) {
        let index = state.treeview.findIndex((item: any) => {
            return item == payload
        })
        state.treeview.splice(index, 1)
    },

    //RESET
    resetProjectHelpers(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
